export const WEEKDAY_LABELS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];
export const MONTH_LENGTHS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // année type non bissextile
export const DEFAULT_WEEKDAY_PCT = Array(7).fill(100 / 7);

const rainToInflowM3 = (rainMm, areaM2) => Math.max(0, rainMm) * areaM2 / 1000; // area déjà "utile" (coeff inclus)

/**
 * Construit une "année type" de 365 jours à partir du besoin mensuel et de la pluviométrie
 * mensuelle : la pluie est répartie uniformément sur les jours du mois, le besoin est réparti
 * selon le profil hebdomadaire (weekdayPct), normalisé par mois pour que la somme des jours
 * d'un mois reste égale au besoin mensuel exact.
 */
export const buildSyntheticYearDays = (monthlyNeed, rainfall, weekdayPct) => {
  const days = [];
  let weekdayCursor = 0; // cycle continu Lun..Dim sur toute l'année
  for (let m = 0; m < 12; m++) {
    const dim = MONTH_LENGTHS[m];
    const counts = Array(7).fill(0);
    for (let d = 0; d < dim; d++) counts[(weekdayCursor + d) % 7]++;
    const weightedSum = counts.reduce((a, c, w) => a + c * weekdayPct[w], 0);
    for (let d = 0; d < dim; d++) {
      const weekday = (weekdayCursor + d) % 7;
      const rainDay = rainfall[m] / dim;
      const demandDay = weightedSum > 0 ? monthlyNeed[m] * weekdayPct[weekday] / weightedSum : 0;
      days.push({ weekday, rain: rainDay, demand: demandDay });
    }
    weekdayCursor += dim;
  }
  return days;
};

export const simulateOneCapacity = (days, capacity, areaM2, initialStorage) => {
  let storage = Math.min(Math.max(initialStorage, 0), capacity);
  let deficitDays = 0, deficitTotal = 0, overflowTotal = 0, demandTotal = 0, servedTotal = 0;
  for (const day of days) {
    const inflow = rainToInflowM3(day.rain, areaM2);
    storage += inflow;
    let overflow = 0;
    if (storage > capacity) { overflow = storage - capacity; storage = capacity; }
    const demand = day.demand;
    const served = Math.min(storage, demand);
    storage -= served;
    const deficit = demand - served;
    if (deficit > 1e-9) deficitDays++;
    deficitTotal += deficit; overflowTotal += overflow; demandTotal += demand; servedTotal += served;
  }
  const reliability = demandTotal > 1e-9 ? servedTotal / demandTotal : 1;
  return { capacity, deficitDays, deficitTotal, overflowTotal, demandTotal, servedTotal, reliability };
};

export const simulateCapacityRange = (days, vmin, vmax, vstep, areaM2, initialStorage) => {
  if (vstep <= 0) throw new Error('Le pas de volume doit être > 0.');
  if (vmax < vmin) { const t = vmin; vmin = vmax; vmax = t; }
  const n = Math.floor((vmax - vmin) / vstep) + 1;
  const results = [];
  for (let i = 0; i < n; i++) results.push(simulateOneCapacity(days, vmin + i * vstep, areaM2, initialStorage));
  return results;
};
